import type { Permission } from "@soulbyte/core";
import { usePermissionEntitlements } from "@frontegg/react";
import { useHasRole } from "../auth.roles";

export function useIsEntitled(permission: Permission) {
  const { isEntitled } = usePermissionEntitlements(permission);
  return isEntitled;
}

/**
 * True when the caller holds the SuperAdmin role. Backend permission gates
 * (CanUseModuleFeature and every other gate in the service) pass superadmins
 * without checking the individual permission, so UI locks that mirror those
 * gates must apply the same bypass or they render controls locked that the
 * API would happily accept.
 */
export function useIsSuperAdmin() {
  return useHasRole("SuperAdmin");
}
